module.exports = __webpack_public_path__ + "static/media/colombia.a5e3f97b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/colombia.png
// module id = 1175
// module chunks = 0